/**
 * SubscriptionInfoRemapper
 *
 * Maps SubscriptionInfoDto (data layer) → SubscriptionInfoEntity (domain).
 * Flutter source: lib/data/models/subscription_info.dart
 */
import type { SubscriptionInfoDto } from '@/data/dtos/info/subscriptionInfoDto';
import type { JsonObject } from '@/data/types/json';
import type { SubscriptionInfoEntity } from '@/domain/entities/info/subscriptionInfoEntity';

export class SubscriptionInfoRemapper {
  static fromDto(dto: SubscriptionInfoDto): SubscriptionInfoEntity {
    return { ...dto };
  }

  static fromJson(data: JsonObject): SubscriptionInfoDto {
    return {
      coins: (data['coins'] as number | undefined) ?? 0,
    };
  }

  static fromJsonList(dataList: JsonObject[]): SubscriptionInfoDto[] {
    return dataList.map(SubscriptionInfoRemapper.fromJson);
  }
}
